import { Box, Button, Typography } from "@mui/material";
import { ExpandLess, ExpandMore, Person } from "@mui/icons-material";

interface ParticipantAddHeaderProps {
  isExpanded: boolean;
  disabled: boolean;
  onToggleExpanded: () => void;
}

/**
 * Nagłówek formularza dodawania zawodnika
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko nagłówek
 */
export default function ParticipantAddHeader({
  isExpanded,
  disabled,
  onToggleExpanded,
}: ParticipantAddHeaderProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, px: { xs: 2, sm: 3 } }}>
      {/* <Person sx={{ color: "#6366f1", fontSize: 20 }} /> */}
      <Typography variant="h5" sx={{ fontWeight: 600, color: "#2f2f2f" }}>
        Dodaj zawodnika
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      <Button
        variant="outlined"
        size="small"
        startIcon={isExpanded ? <ExpandLess /> : <ExpandMore />}
        onClick={onToggleExpanded}
        disabled={disabled}
        sx={{
          color: "#6366f1",
          borderColor: "#6366f1",
          "&:hover": { backgroundColor: "#f1e7de", borderColor: "#6366f1" },
          py: 0.5,
          px: 1.5,
          fontSize: "0.75rem",
          minWidth: "auto",
          "&:disabled": {
            color: "#9ca3af",
            borderColor: "#9ca3af",
          },
        }}
      >
        {isExpanded ? "Ukryj" : "Pokaż"}
      </Button>
    </Box>
  );
}
